import { Outlet, createRootRoute } from "@tanstack/react-router"
import { withProfiler } from "@/error"
import { Root } from "@/base"

export const Route = createRootRoute({
  component: withProfiler(() => (
    <Root>
      <Outlet />
    </Root>
  )),
})
